<template>
  <div class="d-flex flex-column h-100 w-100 align-center">
    <ScoresTable
      v-if="filteredReport && !singleMode"
      class="flex-grow-1 align-center tw-min-h-0"
      :on-check-click="onCheckClick"
      :report="filteredReport"
      :report-filters="filters"
      :show-images="showImages"
      :selected="selectedStructures"
      @onFilterAdded="$emit('onFilterAdded')"
      @showUnlikely-changed="$emit('showUnlikely-changed', $event)"
    />
    <HazardTable
      v-if="filteredReport && singleMode"
      class="flex-grow-1 align-center tw-min-h-0"
      :hazard-chemical="chemId"
      first-only
    />
  </div>
</template>

<script>
import ScoresTable from './ScoresTable.vue'
import HazardTable from '@/components/hazard/HazardTable.vue'

export default {
  components: {
    HazardTable,
    ScoresTable,
  },

  props: {
    downloading: {
      type: Boolean,
      default: false,
    },
    filteredReport: {
      type: Object,
      default: null,
    },
    singleMode: {
      type: Boolean,
      default: false,
    },
    filters: {
      type: Object,
      required: true,
    },
    showImages: {
      type: Boolean,
      default: false,
    },
    selectedStructures: {
      type: Array,
      default: () => [],
    },
    chemId: {
      type: [String, Number],
      default: null,
    },
    onCheckClick: {
      type: Function,
      required: true,
    },
  },
}
</script>
